var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"counter",class:[
    _vm.size,
    {
      stretch: _vm.stretch,
      ghost: _vm.ghost,
      'has-slot': _vm.$slots.info,
    },
  ]},[_c('span',{staticClass:"bold counter-text",class:{
      'text-regular': _vm.size === 'large',
      'text-small': _vm.size !== 'large',
    }},[_vm._v(" "+_vm._s(_vm.value)+" ")]),(_vm.$slots.info)?_c('span',{staticClass:"bold counter-info text-small"},[_vm._t("info")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }